import type { components } from "@/shared/api";

type MatchSummary = components["schemas"]["MatchSummary"];

// Обычный матч 6 на 6: его можно разобрать и оценить. Street Brawl и другие режимы —
// на другой карте, разбора и оценки у них нет. Режим ещё неизвестен (`null`, история его
// допишет) — считаем обычным, как бэкенд.
export const isNormalGame = (match: Pick<MatchSummary, "game_mode">): boolean =>
  match.game_mode === null || match.game_mode === "normal";
